import Vue from 'vue';
import VueRouter from 'vue-router';
import S_Router from '@/__vue2stone/service/app/router';
import Router_Factory from './factory';

Vue.use(VueRouter);
const oldRoute = [
  {
    path: '/verify/email/:userId',
    name: 'VerifyEmail',
    component: () => import('@/views/VerifyEmail.vue'),
    props: true,
  },
  {
    path: '/forget/password/:userId',
    name: 'ForgetPassword',
    component: () => import('@/views/ForgetPassword.vue'),
    props: true,
  },
];

const routes = [
  ...oldRoute,
  {
    path: '/showroom',
    name: 'showroom',
    component: () => import('@/views/ShowRoom.vue'),
  },
  {
    path: '/signin',
    name: 'signin',
    component: () => import('@/views/Signin.vue'),
  },
  {
    path: '/first-signin',
    name: 'firstSignin',
    component: () => import('@/views/FirstSignin.vue'),
  },
  {
    path: '/signout',
    name: 'signout',
    component: () => import('@/views/Signout.vue'),
  },
  {
    path: '/',
    redirect: '/home',
    props: true,
    meta: {
      middleware: 'auth',
      template: 'auth',
    },
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/Home.vue'),
    meta: {
      middleware: 'auth',
      template: 'auth',
    },
  },
  {
    path: '/verify-email/:userId',
    name: 'verifyEmail',
    component: () => import('@/views/VerifyEmail.vue'),
    props: true,
  },
  {
    path: '/forget-password/:userId',
    name: 'forgetPassword',
    component: () => import('@/views/ForgetPassword.vue'),
    props: true,
  },
  {
    path: '/send-email',
    name: 'sendEmail',
    component: () => import('@/views/SendEmail.vue'),
  },
  {
    path: '/not-found',
    name: 'notFound',
    component: () => import('@/views/NotFound.vue'),
  },
  {
    path: '*',
    redirect: 'not-found',
    component: () => import('@/views/NotFound.vue'),
  },
  Router_Factory,
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(S_Router.middlewareAuth);
router.beforeEach(S_Router.middlewareScope);
router.beforeEach(S_Router.middlewareParamsId);
router.beforeEach(S_Router.recordPage);

export default router;
